﻿/* 
Object:         AppSettings
Description:    Get the appsettings for example the setting used to define the subfolder where it is hosted.
Used in:        Everywhere where AJAX calls are made 
*/

window.appsettings = function () {
    // settings
    var _subDirectory = "";

    return {
        /**
         * Initiate and set the local settings variabeles read from the appsettings.json
         * This is done by reading it server side and send the variabeles to the viewmodel in the javascript.
         * This initiate function is called in the login page and the home template (root).
         * @param {string} subDirectory
         */
        setSettings: function (subDirectory) {
            _subDirectory = subDirectory;
        },

        /**
         * Get the setting what kind of subfolder has been set.
         */
        getSubDirectory: function () {
            return _subDirectory;
        },

        /**
         * Get the setting what kind of subfolder has been set. This method is specific for kendo.
         * Kendo uses the url from the address url textbox as base.
         * @param {string} localUrl
         */
        getLocalUrl(localUrl) {
            if (_subDirectory != "") {
                return _subDirectory + "/" + localUrl;
            }

            return localUrl;
        },

        /**
         * Construct a url with the subfolder. This is called everywhere a AJAX call is made.
         * This is seperated from the kendo ui javascript framework. The kendo framework has it's own solution. 
         * @param {string} localUrl
         */
        getUrl: function (localUrl) {
            var getUrl = window.location;

            // Split the string 
            var splittedString = localUrl.split('/');

            // 1. Detect if the beginning of the local url has the subfolder. If so. construct a url without additional subfolder from the configuration.
            if (splittedString[0] == _subDirectory) {
                return getUrl.protocol + "//" + getUrl.host + "/" + localUrl;
            }

            // 2. If none has been detected. Construct the url with the additional subfolder. If any is configured.
            if (_subDirectory != "") {
                return getUrl.protocol + "//" + getUrl.host + "/" + _subDirectory + "/" + localUrl;
            }

            // 3. When none is configured. return a url without the additional subfolder. 
            return getUrl.protocol + "//" + getUrl.host + "/" + localUrl;
        }
    }
}();